<template>
  <div class="saas-notice">
    <img :src="require('@/assets/images/staticH5/multiVersion-01.jpg')" alt="头部图片" class="header-img" />
    <div class="main-content">
      <!-- <p class="thin-font">面向所有已实名的客户限时免费使用高级版会员</p>
      <p class="thin-font">活动期间，购买1年高级版/智能版，额外赠送1年同版本使用权+1000份签署流量包（1年有效期）</p>
      <p class="thin-font division-word">活动时间：11月11日-12月31日</p>

      <p class="thin-font division-word">上线后的企业SaaS分为：</p>
      <p class="bold-font">基础版、高级版、智能版、区块链智能版共4个版本</p> 
      <p class="bold-font dobble-division-word">为满足不同企业业务需求，我们提供以下4个版本的电子合同服务:</p> -->
      <div class="card-item">
        <div class="card-intro">
          <p class="card-title">SaaS基础版</p>
          <p class="card-content">满足您办公所需的基础功能</p>
          <p class="divider"></p>
          <p class="apply-scene">适用于初创型企业</p>
        </div>
        <div class="card-price free">免费</div>
      </div>
      <div class="card-item">
        <div class="card-intro">
          <p class="card-title">SaaS高级版</p>
          <p class="card-content">提供“发、签、管、存、裁”等全生命周期电子合同管理服务</p>
          <p class="divider"></p>
          <p class="apply-scene">适用于中型企业，需要管理员工、管理合同</p>
        </div>
        <p class="card-price"><span class="price-number">58,000</span>元/年</p>
      </div>
      <div class="card-item">
        <div class="card-intro">
          <p class="card-title">SaaS智能版</p>
          <p class="card-content">依托于独家AI技术提供智能审阅、智能模板、智能台账等智能、高效合同管理服务</p>
          <p class="divider"></p>
          <p class="apply-scene">适用于大型、集团型企业需要高效、智能的管理合同</p>
        </div>
        <p class="card-price"><span class="price-number">198,000</span>元/年</p>
      </div>
      <div class="card-item">
        <div class="card-intro">
          <p class="card-title">SaaS区块链智能版</p>
          <p class="card-content">联合蚂蚁区块链共同推出自动执行、自动催收、视频双录、蚁盾风控，保障您的安全办公</p>
        </div>
        <p class="card-price"><span class="price-number">298,000</span>元/年</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'multiVersionH5',
  mounted() {
    this.$tsignData.track('H5_multiVersion_pageview')
  },
}
</script>

<style lang="less" scoped>
.saas-notice {
  // background: linear-gradient(166deg, #363a45 0%, #2c2c2f 100%);
  background: #191777;
  .header-img {
    width: 100%;
    height: auto;
  }
  .main-content {
    width: 87.2%;
    margin: 23px auto 0;
    padding-bottom: 25px;
    .thin-font {
      font-size: 15px;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
    }
    .division-word {
      line-height: 24px;
      margin: 21px 0 3px;
    }
    .dobble-division-word {
      line-height: 24px;
      margin: 40px 0 3px;
    }
    .bold-font {
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
      line-height: 20px;
    }
    .card-item {
      width: 100%;
      height: 270px;
      box-shadow: 2px 4px 10px 0px rgba(1, 0, 76, 0.5);
      border-radius: 6px;
      margin-top: 24px;

      &:nth-of-type(1) .card-intro {
        background-image: url('../assets/images/staticH5/card-img1.jpg');
      }
      &:nth-of-type(2) .card-intro {
        background-image: url('../assets/images/staticH5/card-img2.jpg');
      }
      &:nth-of-type(3) .card-intro {
        background-image: url('../assets/images/staticH5/card-img3.jpg');
      }
      &:nth-of-type(4) .card-intro {
        background-image: url('../assets/images/staticH5/card-img4.jpg');
      }

      &:nth-of-type(1) .card-price {
        background-image: url('../assets/images/staticH5/multiversion_base.svg');
      }
      &:nth-of-type(2) .card-price {
        background-image: url('../assets/images/staticH5/multiversion_high.svg');
      }
      &:nth-of-type(3) .card-price {
        background-image: url('../assets/images/staticH5/multiversion_ai.svg');
      }
      &:nth-of-type(4) .card-price {
        background-image: url('../assets/images/staticH5/multiversion_block.svg');
      }

      .card-intro {
        height: 165px;
        color: #fff;
        width: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
        padding: 24px;
        border-top-left-radius: 7px;
        border-top-right-radius: 7px;

        .card-title {
          font-size: 19px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 25px;
          text-shadow: 0px 1px 2px #646667;
          margin-bottom: 7px;
        }
        .card-content {
          max-width: 275px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 20px;
          margin-bottom: 21px;
        }
        .divider {
          width: 279px;
          height: 1px;
          background-image: linear-gradient(
            to right,
            rgba(255, 255, 255, 0.13),
            rgba(255, 255, 255, 0.1),
            rgba(255, 255, 255, 0.025),
            rgba(255, 255, 255, 0)
          );
          background-image: -webkit-gradient(linear, 0% 75%, 85% 100%, from(rgba(255, 255, 255, 0.13)), to(rgba(255, 255, 255, 0)));
        }
        .apply-scene {
          position: absolute;
          bottom: 24px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.75);
        }
      }

      @media (max-width: 320px) {
        &:nth-of-type(3) .card-intro {
          .apply-scene {
            bottom: 4px;
            width: 240px;
          }
          .card-content {
            margin-bottom: 6px;
          }
        }
      }

      .card-price {
        height: 105px;
        padding: 32px 23px 0;
        background-position: right;
        background-repeat: no-repeat;
        border-bottom-left-radius: 7px;
        border-bottom-right-radius: 7px;
        background-color: #fff;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;

        &.free {
          color: rgba(0, 0, 0, 0.85);
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          line-height: 33px;
        }

        .price-number {
          font-size: 32px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #e75245;
          line-height: 37px;
          margin-right: 2px;
        }
      }
    }
  }
}
</style>
